'use client';

import { createContext, ReactNode, useContext, useState } from 'react';

export interface UserData {
  encryptedUserId?: string;
  apiToken?: string;
  merchantId?: string;
  email: string;
  mobileNumber: string;
  password?: string;
  role?: string;
  companyStatus?: string;
  emailVerified?: boolean;
  companyName?: string;
  isNewUser?: boolean;
  kybStatus?: string;
  listOfCommercialRegistration?: any[]; // Replace 'any' with your actual strict type if you have one
  tncAccepted?: boolean;
}

interface AuthContextType {
  userData: UserData | null;
  setUserData: (data: UserData | null) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [userData, setUserData] = useState<UserData | null>(null);

  return (
    <AuthContext.Provider value={{ userData, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
